import React from "react";

import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";

const MessagePanelOpenCard = ({
  messsageUnreadCount,
  setOpenMessagePanel,
  setMessageMenu,
  t,
}) => {
  const handleClick = React.useCallback(() => {
    setOpenMessagePanel(true);
    setMessageMenu(null);
  }, []);
  return (
    <Card
      sx={{
        background: "#FBEBCB",
        width: "100%",
        padding: "16px",
        my: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
      }}
    >
      <ChatOutlinedIcon sx={{ fontSize: "40px", mb: 1 }} />
      <Typography fontSize={"30px"} fontWeight={"500"} fontFamily={"Poppins"}>
        {messsageUnreadCount}
      </Typography>
      <Typography fontSize={"16px"} variant="body1" fontFamily={"Poppins"}>
        {t("unreadMessages")}
      </Typography>
      <Button
        sx={{
          background: "white",
          color: "#37773E",
          margin: "15px 0px",
          "&:hover": {
            color: "white",
          },
          borderRadius:"4px"
        }}
        size="large"
        variant="contained"
        fullWidth
        onClick={handleClick}
      >
        {t("seeAll")}
      </Button>
    </Card>
  );
};

export default MessagePanelOpenCard;
